import { useEffect, useState } from "react";
const useResizeWindow = (callback, timeout = 100) => {
  const [value, setValue] = useState(void 0);
  useEffect(() => {
    let timeoutId;
    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => setValue(callback()), timeout);
    };
    if (typeof (window == null ? void 0 : window.ResizeObserver) === "function") {
      const resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(document.body);
      return () => resizeObserver.unobserve(document.body);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [callback, timeout]);
  return value;
};
var useResizeWindow_default = useResizeWindow;
export {
  useResizeWindow_default as default
};
